declare global {
  interface Window {
    /** Affiliate referral id the Tolt script sets from the visitor's referral link. */
    tolt_referral?: string;
  }
}

/** Wire key Paddle's `customData` carries the referral under — must match the API's `PADDLE_CUSTOM_DATA_TOLT_REFERRAL_KEY`. */
export const TOLT_REFERRAL_CUSTOM_DATA_KEY = 'tolt_referral';

/**
 * The live Tolt referral id, or `undefined` when the script never set one (not
 * loaded, ad-blocked, or no referral link). Blank/whitespace counts as absent so
 * callers can spread the result without sending an empty string.
 */
export function getToltReferral(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  const value = window.tolt_referral;
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}
